import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AlertType } from '../types/common.types';

export const showAlert = createAction<{
    message: string;
    type?: AlertType;
    duration?: number;
}>('common/showAlert');

export const hideAlert = createAction<string>('common/hideAlert');

export const clearAlert = createAction('common/clearAlert');

export const showCriticalAlert = createAsyncThunk(
    'common/showCriticalAlert',
    async (message: string, { dispatch }) => {
        dispatch(
            showAlert({
                message,
                type: AlertType.CRITICAL,
                duration: 5000
            })
        );
    }
);

export const showSuccessAlert = createAsyncThunk(
    'common/showSuccessAlert',
    async (message: string, { dispatch }) => {
        dispatch(
            showAlert({
                message,
                type: AlertType.SUCCESS,
                duration: 5000
            })
        );
    }
);
